import { Resource as ResourceAPI } from '@sweetspot/shared/data-access/api-platform'

export enum SideBarMode {
  ADD_RESOURCE = 'ADD RESOURCE',
  EDIT_RESOURCE = 'EDIT RESOURCE',
  ARCHIVE_RESOURCE = 'ARCHIVE RESOURCE',
  ABOUT_RESOURCES = 'ABOUT RESOURCES',
  RESOURCES_ACTION_ITEMS = 'RESOURCES ACTION ITEMS',
  RESOURCE_ACTION_ITEMS = 'RESOURCE ACTION ITEMS',
}

export interface Resource extends ResourceAPI {
  isNew?: boolean
}

export interface ResourcesStore {
  timezone: string
  setTimezone: (timezone: string) => void
  isSideBarOpen: boolean
  toggleSideBar: (mode?: SideBarMode) => void
  sideBarMode?: SideBarMode
  areResourcesLoading: boolean
  resources: Resource[]
  selectedResource: Resource | null
  setResources: (resources: Resource[]) => void
  setSelectedResource: (resource: Resource | null) => void
  setAreResourcesLoading: (areResourcesLoading: boolean) => void
  addResource: (resource: Resource) => void
  updateResource: (updatedResource: Resource) => void
  archiveResource: (resourceId: string) => void
}
